import { ReplicationState } from '../replicate';
import { RxdbCollectionNameV2 } from '../RxdbCollectionNameV2';
import { FamilyMember } from './FamilyMember';
import { initialSync } from './initialSync';

export function create<T = unknown>(
  name: RxdbCollectionNameV2,
  replicationState: ReplicationState<T>,
  // We don't care about the types of the parents.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parents?: FamilyMember<any>[],
): FamilyMember<T> {
  const familyMember: FamilyMember<T> = {
    method: initialSync,
    name,
    parents,
    replicationState,
    syncState: {
      asOf: new Date(),
      description: 'Ready for Sync',
    },
  };
  return familyMember;
}
